import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const RegNow = ({ selectedForms, eventUniqueId }) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const storedUserId = localStorage.getItem("visitor_id");
    setUserId(storedUserId);
  }, []);

  const handleButtonClick = (formfor) => {
    const selectedForm = selectedForms.find((form) => form.formfor === formfor);
    if (selectedForm) {
      if (userId) {
        navigate(`/form/${selectedForm.id}/${eventUniqueId}`);
      } else {
        navigate("/login");
      }
    }
  };

  const availableFormTypes = ["Speaker", "Visitor", "Exhibitor", "Delegate"];

  return (
    <div className="bg-salt p-2 regbtnn regbtnn box_detail">
      <div className="intrecrd">
        {availableFormTypes.map((type) => {
          const isAvailable = selectedForms.some((form) => form.formfor === type);
          return isAvailable ? (
            <Button
              key={type}
              onClick={() => handleButtonClick(type)}
              className="followbtn mb-3"
            >
              Register As {type}
            </Button>
          ) : null;
        })}
      </div>
    </div>
  );
};

export default RegNow;
